import { indexApi } from '@/api/indexApi';
import { tradeApi } from '@/api/exchange.page';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { getterTypes } from '@/store/getter-types';
import { mutationTypes } from '@/store/mutation-types';
// import { socketName } from '../../../common/constants/globalConfig';
import tool from '@/common/js/tool';
// import { getterTypes } from '../../../store/getter-types';
// import tradeAreaMixin from '@/common/mixin/tradeArea';
import tradeMixin from '@/common/mixin/tradeMixin';
// TODO 添加收藏功能未做，获取收藏的交易对未做
export default {
  name: 'Market',
  props: {
    marketList: {
      type: Object,
      default: null
    },
    marketListGroup: {
      type: Array,
      default: null
    },
    clickable: {
      type: Boolean,
      default: null
    }
  },
  mixins: [tradeMixin],
  data() {
    return {
      activeTab: 0,
      ripple: false,
      hasScroll: false,
      loading: true,
      unwatch: null
      // title: '',
    };
  },
  // created() {
  // if (this.title==='') this.title = 'GRXTrade'
  // document.title = this.title;
  // },
  methods: {
    ...mapActions(['getMarketList_action', 'getMarketGroup_action', 'updateMarketList_action']),
    ...mapMutations([mutationTypes.SET_CURRENTMARKET, mutationTypes.SET_COLLECTED_MARKETS_SYMBOLS, 'SET_CURRENT_MARKET_BAR']),
    // init() {
    //   let timer = setTimeout(() => {
    //     clearTimeout(timer);
    //     this.hasScroll = true;
    //   }, 500);
    //   this.subscribeMarketList();
    //   this.getMarketList();
    //   /* 监听当前交易市场，并设置默认显示的tab项。设置完成后移除监听 */
    //   this.unwatch = this.$watch('Getter_Current_Market', (newVal) => {
    //     // this.currentTradeArea = this.findTradeAreaBySymbol(newVal.symbol);
    //     this.currentTradeArea = newVal;
    //     // this.currentTradeArea.filteredData = this.filterData(this.currentTradeArea);
    //     this.activeTab = this.currentTradeArea.marketCoin;

    //     this.unwatch();
    //     this.unwatch = null;
    //     this.subscribeMarkets();
    //   });
    // },
    // // 获取交易市场列表
    // async getMarketList() {
    //   await this.getMarketGroup_action();
    //   await this.getMarketList_action();
    //   this.marketList = this.getSortedMarketListByCurrency;
    //   this.loading = false;
    //   this.$emit('tradeAreaLoaded', this.getSortedMarketListByCurrency);
    // },
    // market点击事件
    marketItemClick(selectedMarket) {
      if (this.clickable) {
        this.SET_CURRENTMARKET(selectedMarket);
        // this.SET_CURRENT_MARKET_BAR(selectedMarket);
        this._pushUrl(selectedMarket);
      }
    },
    // 判断指定symbol的交易对是否被收藏了
    // isCollected(symbol) {
    //   return symbol in this.Getter_CollectedMarketSymbols;
    // },
    // 处理收藏交易对功能
    // processCollect(symbols, isCollect) {
    //   if (!symbols) {
    //     console.error('processCollect 必须传递symbol');
    //     return;
    //   }
    //   if (!this.Getter_Token) {
    //     this.$q.notify({
    //       message: '请先登录！',
    //       type: 'warning',
    //       position: 'top',
    //     });
    //     return;
    //   }
    //   if (({}).toString.call(symbols) !== '[object Array]') {
    //     symbols = [symbols];
    //   }
    //   if (typeof isCollect === 'undefined') {
    //     isCollect = true;
    //   } else {
    //     isCollect = !!isCollect;
    //   }
    //   tradeApi.collectMarket(symbols)
    //     .then((res) => {
    //       if (res.errcode === 0) {
    //         if (!isCollect) {
    //           this.$q.notify({
    //             message: '收藏成功！',
    //             type: 'positive',
    //             position: 'top',
    //           });
    //           let obj = {};
    //           symbols.forEach(item => {
    //             obj[item] = 1;
    //           });
    //           this.SET_COLLECTED_MARKETS_SYMBOLS(obj);
    //           obj = null;
    //         } else {
    //           this.$q.notify({
    //             message: '已取消收藏！',
    //             type: 'positive',
    //             position: 'top',
    //           });
    //           let obj = {};
    //           symbols.forEach(item => {
    //             obj[item] = -1;
    //           });
    //           this.SET_COLLECTED_MARKETS_SYMBOLS(obj);
    //           obj = null;
    //         }
    //         this.$forceUpdate();
    //       }
    //     });
    // },
    // 点击交易对后跳转路由
    _pushUrl(selectedMarket) {
      const query = {
        pair: selectedMarket.symbol
      };
      this.$router.replace({
        path: '/exchange',
        query: { ...query }
      });
    },
    // subscribeMarketList() {
    //   this.$socket.subscribe('marketList', value => {
    //     if (value) {
    //       if (this.Getter_Current_Market.symbol == value.data.symbol) {
    //         let lastPrice = this.decimalRetain(value.data.close, value.data.priceDec);
    //         this.exchangeTitleChange(lastPrice, value.data.coin, value.data.marketCoin);
    //       }
    //       this.updateMarketList_action(value.data);
    //     }
    //   });
    // },
    // unsubscribeMarketList() {
    //   this.$socket.unsubscribe('marketList');
    // },
    convertPair(market) {
      return market.coin + '/' + market.marketCoin;
    },
    convertDecimal(value, decimal) {
      return tool.decimalRetain(parseFloat(value), decimal);
    },
    init(value) {
      this.loading = false;
      for (let index in this.marketListGroup) {
        if (value.marketCoin === this.marketListGroup[index]) {
          this.activeTab = Number(index);
        }
      }
    },
    decimalRetain: tool.decimalRetain
  },
  watch: {
    // Getter_Socket_State(connected) {
    //   if (connected) {
    //     this.init();
    //   }
    // },
    Getter_Current_Market(value) {
      this.init(value);
    }
  },
  computed: {
    ...mapGetters([
      getterTypes.Getter_Token,
      getterTypes.Getter_CollectedMarketSymbols,
      getterTypes.Getter_Current_Market,
      'getMarketGroup',
      'getSortedMarketListByCurrency',
      getterTypes.Getter_Socket_State
    ])
  },
  mounted() {
    if (!this.isEmpty(this.Getter_Current_Market)) {
      this.init(this.Getter_Current_Market);
    }
  }
  // beforeDestroy() {
  //   if (this.unwatch) {
  //     this.unwatch();
  //   }
  // },
};
